import React from "react";
import { Link } from "react-router-dom";

// import { Template } from "../../hooks/useInsertTemplate";
import useTranslations from "../../hooks/useTranslations";
import { H5, Span } from "../wombat-ui";

type TemplateCardProps = {
  template?: any; // TODO: use the template definition from the mad creation branch
};

const TemplateCard: React.FC<TemplateCardProps> = ({ template }) => {
  const t = useTranslations();

  return (
    <Link to={`/templates/${template.slug}/edit`} role="button">
      <div
        tabIndex={0}
        role="button"
        className="flex flex-col flex-grow h-full max-w-md p-1 px-6 py-3 rounded-lg shadow-md focus:outline-none ring-4 ring-white bg-light-0 hover:shadow-lg focus:shadow-lg"
      >
        <H5 className="flex items-center justify-between">
          {template.title}
          <span
            className="flex-shrink-0 w-2 h-2 rounded-sm text-dark-100"
            style={{
              backgroundColor:
                template?.color === "#ffffff"
                  ? "rgb(76, 86, 106)"
                  : template?.color,
            }}
          />
        </H5>
        <Span className="pt-2 text-xs text-light-900">
          {template?.description
            ? template.description
            : t("templates.noDescription")}
        </Span>
      </div>
    </Link>
  );
};

export default React.memo(TemplateCard);
